import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    width: '100%',
    padding: '0px 8px'
  },
  iconWrapper: {
    display: 'inline-flex',
    flexShrink: 0
  },
  icon: {
    color: capitalDesignTokens.foundations.colors.red700
  },
  text: {
    paddingBottom: '0px'
  }
});
